import { ActionFunction } from 'react-router-dom'

import Collection from '@models/Collection'
import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const removeFromCollectionAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()

  const collection_id = formData.get('collectionId')
  const collection_type = formData.get('collectionType')
  const score_ids = formDataToArray(formData.get('scoreIds'))

  return http.action.post<RemoveFromCollectionResponse>(ApiRoutes.collections.removeItemsPath(), {
    collection_id,
    collection_type,
    score_ids,
  })
}

export default removeFromCollectionAction

export type RemoveFromCollectionResponse = {
  collection: Collection
  collection_items: string[]
  count: number
  failed: string[]
}
